
export function getRecordPlayerOptions (record) {
  let options = {
    url: record.play_link,
    mimetype: 'video/mp4',
    thumbnail: record.thumbnail_link,
  }
  if (record.record_type === 'IMAGE' && record.media) {
    const original = record.media.find(el => el.name === 'original')
    return {
      url: original.url,
      mimetype: original.mimetype,
      thumbnail: record.thumbnail_link
    }
  }
  if (record.media) {
    const vod = record.media.find(el => el.name === 'vod')
    const sprite = record.media.find(el => el.name === 'thumbspritehoriz')
    if (vod) {
      options = {
        url: vod.url,
        mimetype: vod.mimetype,
        thumbnail: record.thumbnail_link,
        width: vod.width,
        height: vod.height
      }
      if (sprite) {
        options.sprite = {
          url: sprite.url,
          h_interval: sprite.sprite_interval_h,
          height: sprite.height,
          width: sprite.width
        }
      }
    }
  }
  return options
}
